


















































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import ImageUploader from '../../files/_components/imageUploader.vue';
import DatePicker from '../../../components/date-picker.vue';

@Component({
  components: {
    DatePicker,
    ImageUploader,
  },
})
export default class DlgPressNew extends Vue {
  public $refs!: {
    image: any,
    form: any,
    file: any,
  };

  private dialog: boolean = false;
  private valid: boolean = true;
  private press: any = {};
  private loading: boolean = false;
  private file: any = {};
  private selectedFile: any;
  private fileName: any = '';
  private radio: number = 0;

  @Action('press/create') private pressCreate!: any;
  @Action('press/read') private pressGetAll!: any;
  @Action('press/uploadFile') private uploadFile!: any;
  @Getter('rules/all') private rules!: any;

  private selectFile() {
    if (this.loading) {
      return;
    }
    this.$refs.file.click();
  }

  private onFilePicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.fileName = files[0].name;
      if (!this.file.title) {
        this.file.name = files[0].name;
      }

      this.selectedFile = files[0];
    }
  }

  private async save() {
    this.press.title = this.press.title.trim();
    this.press.pressDate = this.press.pressDate.trim();

    if (!this.$refs.form.validate()) {
      return;
    }

    this.loading = true;

    if (this.radio === 1) {
      this.press.url = await this.uploadFile(this.selectedFile);
      this.press.url = `https://files.ihrespezialisten.at/${this.press.url}`;
    }

    this.press.imageUrl = await this.$refs.image.doUpload();
    const success = await this.pressCreate(this.press);

    this.loading = false;

    if (success) {
      this.press = {};
      this.$refs.image.reset();
      this.$refs.form.reset();
      this.pressGetAll();
      this.dialog = false;
    }
  }
}
